(function () {
  if (window.swapwearFetch) return;

  var NETWORK_RETRY_DELAY_MS = 350;
  var REQUEST_TIMEOUT_MS = 12000;
  var RESTORE_TIMEOUT_MS = 5000;
  var NAVIGATION_TEARDOWN_WINDOW_MS = 5000;
  var mutationQueue = Promise.resolve();
  var cartReadsInFlight = {};
  var cartMutationGeneration = 0;
  var pendingMutations = 0;
  var queuedMutationVersion = 0;
  var failedMutationVersion = 0;
  var lastConfirmedCart = null;
  var recentCart = null;
  var recentCartEpoch = 0;
  var RECENT_CART_MS = 10000;

  function invalidateRecentCart() {
    recentCart = null;
    recentCartEpoch += 1;
  }

  window.addEventListener('blur', invalidateRecentCart);
  window.addEventListener('pagehide', invalidateRecentCart);
  window.addEventListener('pageshow', invalidateRecentCart);
  window.addEventListener('storage', invalidateRecentCart);
  document.addEventListener?.('visibilitychange', invalidateRecentCart);
  var navigationTeardownStartedAt = 0;

  function markNavigationTeardown() {
    navigationTeardownStartedAt = Date.now();
  }

  function clearNavigationTeardown() {
    navigationTeardownStartedAt = 0;
  }

  window.addEventListener('beforeunload', markNavigationTeardown);
  window.addEventListener('pagehide', markNavigationTeardown);
  window.addEventListener('pageshow', clearNavigationTeardown);

  function isNavigationTeardown() {
    return navigationTeardownStartedAt > 0 &&
      Date.now() - navigationTeardownStartedAt <= NAVIGATION_TEARDOWN_WINDOW_MS;
  }

  function delay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function retryAfterMs(response, attempt, options) {
    var retryAfter = response && response.headers && response.headers.get('Retry-After');
    var retryAfterSeconds = Number(retryAfter);
    if (retryAfter && Number.isFinite(retryAfterSeconds) && retryAfterSeconds >= 0) {
      return Math.min(retryAfterSeconds * 1000, 5000);
    }
    if (options.rateLimitRetryDelay != null) return Number(options.rateLimitRetryDelay);
    return Math.min(500 * Math.pow(2, attempt - 1) + Math.floor(Math.random() * 250), 2500);
  }

  function endpointDetails(input, init) {
    var rawUrl = typeof input === 'string' ? input : input && input.url;
    var url = new URL(rawUrl || '', window.location.origin);
    var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var path = url.pathname;
    var mutation = method !== 'GET' && method !== 'HEAD' && /\/cart\/(?:add|change|update)\.js$/.test(path);
    var productRead = method === 'GET' && /\/products\/[^/]+\/?$/.test(path);
    var tracked = /\/cart\/(?:add|change|update)\.js$/.test(path) ||
      /\/cart\.(?:js|json)$/.test(path) ||
      /\/products\/[^/]+\.js$/.test(path) || productRead;
    return { url: url.href, endpoint: path, method: method, mutation: mutation, tracked: tracked, productRead: productRead };
  }

  function notifyTerminalMutationFailure(details, action) {
    window.dispatchEvent(new CustomEvent('swapwear:request-failed', {
      detail: {
        message: 'That didn’t quite work. Check your connection and try again.',
        mutation: true,
        endpoint: details.endpoint,
        action: action
      }
    }));
  }

  function validCart(cart) {
    return !!(
      cart &&
      typeof cart === 'object' &&
      Array.isArray(cart.items) &&
      Number.isFinite(Number(cart.item_count)) &&
      Number.isFinite(Number(cart.total_price))
    );
  }

  function confirmCart(cart, restored) {
    if (!validCart(cart)) return false;
    var snapshot;
    try {
      snapshot = JSON.parse(JSON.stringify(cart));
    } catch (_) {
      return false;
    }
    lastConfirmedCart = snapshot;
    try { window.swapwearFunnel?.syncCart(snapshot); } catch (_) {}
    window.__swapwearLastConfirmedCart = snapshot;
    if (restored) {
      window.dispatchEvent(new CustomEvent('swapwear:cart-restored', { detail: { cart: snapshot } }));
    }
    return true;
  }

  async function cartFromResponse(response, epoch) {
    try {
      var data = await response.clone().json();
      if (confirmCart(data, false) && epoch === recentCartEpoch) {
        recentCart = { cart: lastConfirmedCart, at: Date.now() };
      }
    } catch (_) {}
  }

  async function fetchCartForRestore(options) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var controller = new AbortController();
    var restoreTimeout = Number(options && options.restoreTimeout);
    if (!Number.isFinite(restoreTimeout) || restoreTimeout <= 0) restoreTimeout = RESTORE_TIMEOUT_MS;
    var timeout = setTimeout(function () { controller.abort(); }, restoreTimeout);
    try {
      var response = await window.fetch(root + 'cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: controller.signal
      });
      if (!response.ok) return null;
      var cart = await response.json();
      return confirmCart(cart, true) ? cart : null;
    } catch (_) {
      return null;
    } finally {
      clearTimeout(timeout);
    }
  }

  function parseMutationBody(body) {
    if (!body) return {};
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (_) { return {}; }
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var properties = {};
      body.forEach(function (value, key) {
        var match = String(key).match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      });
      var item = {
        id: body.get('id'),
        quantity: Number(body.get('quantity') || 1),
        properties: properties
      };
      return { items: [item] };
    }
    return body;
  }

  function lineQuantity(cart, id) {
    if (!validCart(cart)) return 0;
    return cart.items.reduce(function (total, item) {
      var matches = String(item.key || '') === String(id) ||
        String(item.variant_id || item.id || '') === String(id);
      return total + (matches ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  function normalizedProperties(properties) {
    if (!properties || typeof properties !== 'object') return '';
    return Object.keys(properties).sort().map(function (key) {
      return key + '=' + String(properties[key] == null ? '' : properties[key]);
    }).join('&');
  }

  function matchingLineQuantity(cart, requestedItem) {
    if (!validCart(cart)) return 0;
    var requestedKey = String(requestedItem.key || '');
    var requestedId = String(requestedItem.variant_id || requestedItem.id || '');
    var requestedProperties = normalizedProperties(requestedItem.properties);
    return cart.items.reduce(function (total, item) {
      var keyMatches = requestedKey && String(item.key || '') === requestedKey;
      var variantMatches = requestedId && String(item.variant_id || item.id || '') === requestedId;
      var propertiesMatch = normalizedProperties(item.properties) === requestedProperties;
      return total + ((keyMatches || (variantMatches && propertiesMatch)) ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  function mutationWasApplied(details, init, before, after) {
    if (!validCart(after)) return false;
    var body = parseMutationBody(init && init.body);
    if (/\/cart\/add\.js$/.test(details.endpoint) && validCart(before)) {
      var addedItems = Array.isArray(body.items) ? body.items : (body.id != null ? [body] : []);
      return addedItems.length > 0 && addedItems.every(function (item) {
        return matchingLineQuantity(after, item) >= matchingLineQuantity(before, item) + Number(item.quantity || 1);
      });
    }
    if (/\/cart\/change\.js$/.test(details.endpoint) && body.id != null && body.quantity != null) {
      if (!validCart(before)) return false;
      var requestedLineId = String(body.id);
      var exactKeyLine = before.items.find(function (item) {
        return String(item.key || '') === requestedLineId;
      });
      var variantLines = before.items.filter(function (item) {
        return String(item.variant_id || item.id || '') === requestedLineId;
      });
      var beforeLine = exactKeyLine || (variantLines.length === 1 ? variantLines[0] : null);
      if (!beforeLine) return false;
      var matchingLines = after.items.filter(function (item) {
        return String(item.variant_id || item.id || '') === String(beforeLine.variant_id || beforeLine.id || '') &&
          normalizedProperties(item.properties) === normalizedProperties(beforeLine.properties) &&
          String(item.selling_plan_allocation?.selling_plan?.id || '') === String(beforeLine.selling_plan_allocation?.selling_plan?.id || '');
      });
      var afterLine = matchingLines.length === 1 ? matchingLines[0] : null;
      return Number(body.quantity) === 0
        ? matchingLines.length === 0
        : !!afterLine && Number(afterLine.quantity || 0) === Number(body.quantity);
    }
    if (/\/cart\/update\.js$/.test(details.endpoint)) {
      if (body.note !== undefined) return String(after.note || '') === String(body.note || '');
      if (body.updates && typeof body.updates === 'object') {
        return Object.keys(body.updates).every(function (id) {
          return lineQuantity(after, id) === Number(body.updates[id]);
        });
      }
    }
    return false;
  }

  function responseFromCart(cart) {
    return new Response(JSON.stringify(cart), {
      status: 200,
      headers: { 'Content-Type': 'application/json', 'X-SwapWear-Recovered': 'true' }
    });
  }

  function defaultAction(details) {
    if (/\/cart\/add\.js$/.test(details.endpoint)) return 'cart-add';
    if (/\/cart\/change\.js$/.test(details.endpoint)) return 'cart-change';
    if (/\/cart\/update\.js$/.test(details.endpoint)) return 'cart-update';
    if (/\/cart\.(?:js|json)$/.test(details.endpoint)) return 'cart-read';
    if (details.productRead) return 'product-read';
    return details.method.toLowerCase();
  }

  async function waitForMutationQueueToSettle() {
    // New actions can join while an earlier one is settling. Continue until the
    // queue reference itself is stable so the replacement read cannot race a
    // mutation that was already accepted into the queue.
    while (true) {
      var pendingQueue = mutationQueue;
      await pendingQueue.catch(function () {});
      if (pendingQueue === mutationQueue) return;
    }
  }

  async function execute(input, init, options, details, requestGeneration) {
    var epoch = recentCartEpoch;
    var action = options.action || defaultAction(details);
    var before = lastConfirmedCart || window.__swapwearLastConfirmedCart ||
      (window.__initialData && window.__initialData.cart) || null;
    var attempts = 0;
    var retryableCartRead = details.method === 'GET' && /\/cart\.(?:js|json)$/.test(details.endpoint);
    var retryableProductRead = details.productRead;
    var replaySafeMutation = details.mutation && /\/cart\/(?:change|update)\.js$/.test(details.endpoint);
    var maxAttempts = retryableCartRead || details.mutation ? 3 : (retryableProductRead ? 2 : 1);

    while (attempts < maxAttempts) {
      attempts += 1;
      var controller = new AbortController();
      var externalSignal = init && init.signal;
      var externalAborted = !!(externalSignal && externalSignal.aborted);
      var abortFromExternal = function () {
        externalAborted = true;
        controller.abort();
      };
      if (externalSignal && !externalAborted) {
        externalSignal.addEventListener('abort', abortFromExternal, { once: true });
      } else if (externalAborted) {
        controller.abort();
      }
      var timeout = setTimeout(function () { controller.abort(); }, options.timeout || REQUEST_TIMEOUT_MS);
      var cleanupAttempt = function () {
        clearTimeout(timeout);
        if (externalSignal) externalSignal.removeEventListener('abort', abortFromExternal);
      };
      var requestDefaults = { credentials: 'same-origin' };
      if (retryableCartRead && (!init || init.cache == null)) requestDefaults.cache = 'no-store';
      var requestInit = Object.assign(requestDefaults, init || {}, { signal: controller.signal });
      try {
        var response = await window.fetch(input, requestInit);
        // Fetch resolves at headers. Keep the deadline active until the body is
        // received too, otherwise a weak connection can leave callers waiting forever.
        var payload = await response.arrayBuffer();
        response = new Response([204, 205, 304].includes(response.status) ? null : payload, {
          status: response.status, statusText: response.statusText, headers: response.headers
        });
        cleanupAttempt();
        if (response.ok && retryableCartRead && requestGeneration !== cartMutationGeneration) {
          // A mutation began after this cart snapshot was requested. Join (or
          // start) a read only after every queued mutation settles instead of
          // returning another snapshot while the newer mutation is still in flight.
          await waitForMutationQueueToSettle();
          return window.swapwearFetch(input, init || {}, options);
        }
        if (response.ok && /\/cart\/(?:change|update)\.js$|\/cart\.(?:js|json)$/.test(details.endpoint)) {
          await cartFromResponse(response, epoch);
        }
        if (!response.ok && retryableCartRead) invalidateRecentCart();
        var retryableHttpFailure = response.status === 429 || (
          (!details.mutation || replaySafeMutation) && [408, 425, 500, 502, 503, 504].indexOf(response.status) !== -1
        );
        if (retryableHttpFailure && attempts < maxAttempts) {
          await delay(retryAfterMs(response, attempts, options));
          continue;
        }
        if (!response.ok) {
          // Validation/throttle responses are definitive rejections and should
          // reach the form immediately. Restore only after server failures where
          // the mutation result can genuinely be ambiguous, plus a rejected
          // zero-quantity change that may simply target an already-removed line.
          var rejectedMutationBody = parseMutationBody(init && init.body);
          var recoverableStaleRemoval = /\/cart\/change\.js$/.test(details.endpoint) &&
            response.status === 400 && Number(rejectedMutationBody.quantity) === 0;
          var ambiguousMutationHttpFailure = details.mutation &&
            ([408, 425, 500, 502, 503, 504].indexOf(response.status) !== -1 || recoverableStaleRemoval);
          var restoredAfterHttpFailure = ambiguousMutationHttpFailure
            ? await fetchCartForRestore(options)
            : null;
          if (details.mutation && mutationWasApplied(details, init || {}, before, restoredAfterHttpFailure)) {
            return responseFromCart(restoredAfterHttpFailure);
          }
        }
        return response;
      } catch (error) {
        cleanupAttempt();
        if (retryableCartRead) invalidateRecentCart();
        var restored = details.mutation ? await fetchCartForRestore(options) : null;
        if (details.mutation && mutationWasApplied(details, init || {}, before, restored)) {
          return responseFromCart(restored);
        }
        // A caller abort is an intentional cancellation (for example, a newer
        // product view replacing an older one), so it must not be retried or
        // surfaced as a storefront failure.
        if (externalAborted) throw error;
        // A timed-out cart add is ambiguous: the server may still apply it after
        // the browser gives up, so it is never blindly replayed. Quantity changes
        // and updates express an idempotent target state and remain safe to retry.
        if ((!details.mutation || replaySafeMutation) && attempts < maxAttempts) {
          await delay(options.retryDelay || NETWORK_RETRY_DELAY_MS);
          continue;
        }
        if (options.reportFailure !== false && details.mutation && !isNavigationTeardown()) {
          notifyTerminalMutationFailure(details, action);
        }
        if (details.mutation && !restored) confirmCart(before, true);
        error.swapwearFailureType = 'network';
        error.swapwearAttempts = attempts;
        throw error;
      }
    }
  }

  window.swapwearFetch = function (input, init, options) {
    options = options || {};
    var details = endpointDetails(input, init || {});
    if (!details.tracked) return window.fetch(input, init);
    if (!details.mutation) {
      var coalescedCartRead = details.method === 'GET' && /\/cart\.(?:js|json)$/.test(details.endpoint);
      if (!coalescedCartRead) return execute(input, init || {}, options, details, cartMutationGeneration);

      var readGeneration = cartMutationGeneration;
      var readKey = details.url + '::' + readGeneration;
      if (!cartReadsInFlight[readKey]) {
        var readOperation = execute(input, init || {}, options, details, readGeneration);
        cartReadsInFlight[readKey] = readOperation;
        readOperation.finally(function () {
          if (cartReadsInFlight[readKey] === readOperation) delete cartReadsInFlight[readKey];
        }).catch(function () {});
      }
      return cartReadsInFlight[readKey].then(function (response) { return response.clone(); });
    }

    // Every invocation represents a distinct customer action. Serialize actions
    // to avoid stale cart mutations; retries remain inside the same execute call.
    invalidateRecentCart();
    pendingMutations += 1;
    queuedMutationVersion += 1;
    window.dispatchEvent(new CustomEvent('swapwear:cart-pending'));
    var analyticsContext;
    try { analyticsContext = window.swapwearFunnel?.context(); } catch (_) {}
    var operation = mutationQueue.catch(function () {}).then(function () {
      invalidateRecentCart();
      cartMutationGeneration += 1;
      var analyticsBefore = window.swapwearFunnel?.cart() || lastConfirmedCart || window.__swapwearLastConfirmedCart || window.__initialData?.cart;
      return execute(input, init || {}, options, details, cartMutationGeneration).then(async function (response) {
        // One notification per confirmed mutation, after internal retries/recovery.
        if (response.ok && window.swapwearFunnel) {
          try {
            window.swapwearFunnel.mutation(details.endpoint, parseMutationBody(init?.body),
              await response.clone().json(), analyticsBefore, analyticsContext);
          } catch (_) { /* Analytics must never interrupt cart operations. */ }
        }
        return response;
      });
    });
    operation = operation.then(function (response) {
      if (!response.ok) failedMutationVersion += 1;
      return response;
    }, function (error) {
      failedMutationVersion += 1;
      throw error;
    }).finally(function () { pendingMutations -= 1; });
    mutationQueue = operation.catch(function () {});
    return operation;
  };

  window.swapwearFetch.pendingMutations = function () { return pendingMutations; };
  window.swapwearFetch.mutationVersion = function () { return queuedMutationVersion; };
  window.swapwearFetch.failedMutationVersion = function () { return failedMutationVersion; };
  window.swapwearFetch.waitForMutations = waitForMutationQueueToSettle;
  window.swapwearFetch.isValidCart = validCart;
  window.swapwearFetch.confirmCart = function (cart) {
    invalidateRecentCart();
    return confirmCart(cart, false);
  };
  window.swapwearFetch.recentCart = function () {
    if (!recentCart || pendingMutations || Object.keys(cartReadsInFlight).length || document.hidden) return null;
    var age = Date.now() - recentCart.at;
    if (age < 0 || age > RECENT_CART_MS) return null;
    return JSON.parse(JSON.stringify(recentCart.cart));
  };
}());
